const defaultDoctors = [
  {
    name: 'Dr. Sarah Patel',
    specialty: 'Cardiology',
    experience: '12 years',
    imageUrl: 'https://images.unsplash.com/photo-1612349316228-5942a9b489c2?auto=format&fit=crop&w=400&q=80',
    summary: 'Focuses on preventive cardiology, hypertension management, ECG review, and long-term heart-health planning for adults and seniors.',
    achievements: ['Board Certified', 'Published 20+ papers in cardio journals']
  },
  {
    name: 'Dr. James Lee',
    specialty: 'Orthopedics',
    experience: '15 years',
    imageUrl: 'https://plus.unsplash.com/premium_photo-1658506671316-0b293df7c72b?auto=format&fit=crop&w=400&q=80',
    summary: 'Treats joint pain, sports injuries, mobility concerns, and post-injury recovery with patient-friendly rehabilitation plans.',
    achievements: ['Advanced Arthroscopy', 'Speaker at national ortho conference']
  },
  {
    name: 'Dr. Maria Gomez',
    specialty: 'Pediatrics',
    experience: '10 years',
    imageUrl: 'https://plus.unsplash.com/premium_photo-1664475450083-5c9eef17a191?auto=format&fit=crop&w=400&q=80',
    summary: 'Provides child wellness visits, immunization guidance, nutrition support, and developmental care for growing families.',
    achievements: ['Child Welfare Advocate', 'Certified pediatric life support instructor']
  }
]

export default defaultDoctors
